export function setupFullscreenControls() {
  const fullscreenCheckbox = document.getElementById("fullscreen-checkbox") as HTMLInputElement;
  const fullscreenHideUiCheckbox = document.getElementById("fullscreen-hide-ui") as HTMLInputElement;
  const fullscreenStyleRadios = document.querySelectorAll('input[name="fullscreen-style"]') as NodeListOf<HTMLInputElement>;
  
  if (!fullscreenCheckbox) return;

  const updateFullscreenState = async (enter: boolean) => {
    let style = "standard";
    fullscreenStyleRadios.forEach(r => {
      if (r.checked) style = r.value;
    });
    
    const hideUI = fullscreenHideUiCheckbox?.checked;

    try {
      if (enter) {
        if (style === "borderless") {
            // CSS pseudo-fullscreen fallback for borderless or when permission denied
            document.body.classList.add("pseudo-fullscreen");
        } else {
            try {
                await document.documentElement.requestFullscreen();
            } catch (err) {
                console.warn("Native fullscreen rejected, falling back to pseudo-fullscreen", err);
                document.body.classList.add("pseudo-fullscreen");
            }
        }

        if (hideUI) {
          document.body.classList.add("fullscreen-hidden-ui");
        }
      } else {
        if (document.fullscreenElement) {
            await document.exitFullscreen();
        }
        document.body.classList.remove("pseudo-fullscreen");
        document.body.classList.remove("fullscreen-hidden-ui");
      }
    } catch (e) {
      console.error("Fullscreen toggle failed:", e);
      if (enter) {
         fullscreenCheckbox.checked = false;
         document.body.classList.remove("fullscreen-hidden-ui");
         document.body.classList.remove("pseudo-fullscreen");
         alert("Fullscreen failed: " + e); 
      } else {
         document.body.classList.remove("fullscreen-hidden-ui");
         document.body.classList.remove("pseudo-fullscreen");
      }
    }
  };

  fullscreenCheckbox.addEventListener("change", () => {
    void updateFullscreenState(fullscreenCheckbox.checked);
  });
  
  window.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'forward_key') {
          const key = event.data.payload.key;
          if (key === 'F11') {
              fullscreenCheckbox.checked = !fullscreenCheckbox.checked;
              void updateFullscreenState(fullscreenCheckbox.checked);
          } else if (key === 'Escape' && fullscreenCheckbox.checked) {
              fullscreenCheckbox.checked = false;
              void updateFullscreenState(false);
          }
      }
  });

  fullscreenHideUiCheckbox?.addEventListener("change", () => {
      if (fullscreenCheckbox.checked) {
          if (fullscreenHideUiCheckbox.checked) {
              document.body.classList.add("fullscreen-hidden-ui");
          } else {
              document.body.classList.remove("fullscreen-hidden-ui");
          }
      }
  });

  document.addEventListener("keydown", (e) => {
      if (e.key === "F11") {
          e.preventDefault();
          fullscreenCheckbox.checked = !fullscreenCheckbox.checked;
          void updateFullscreenState(fullscreenCheckbox.checked);
      }
      if (e.key === "Escape" && fullscreenCheckbox.checked) {
          fullscreenCheckbox.checked = false;
          void updateFullscreenState(false);
      }
  });
}
